import Vue from 'vue'
import Vuex from 'vuex'
import SpotifyModule from './spotify.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters: {
  },
  modules: {
    SpotifyModule
  }
})
